module.exports = __webpack_public_path__ + "img/2.1da9488f.svg";